import { Controller } from '@hotwired/stimulus'
import { FetchRequest } from '@rails/request.js'

export default class extends Controller {
  static values = {
    url: String
  }

  async generate(event) {
    event.preventDefault()
    console.log('Generating summary...', this.urlValue)

    let summaryEl = this.element.querySelector('textarea')

    if (
      summaryEl.value.length === 0 ||
      (summaryEl.value.length > 0 &&
        window.confirm(
          "Taking this action overwrites anything you've already written in this field. You will lose what's currently here and this cannot be undone. Are you sure you want to generate a new summary?"
        ))
    ) {
      const request = new FetchRequest('POST', this.urlValue, { responseKind: 'json' })
      try {
        const response = await request.perform()
        if (response.ok) {
          const data = await response.json
          summaryEl.value = data.summary
        } else {
          throw new Error('Request failed')
        }
      } catch (error) {
        document.dispatchEvent(
          new CustomEvent('toast', {
            detail: { message: 'Document must be completed before a summary can be generated.' }
          })
        )
      }
    }
  }
}
